import {ApiService} from '../libs/api'
import {DataService} from './data'

export class AiService{

    static async getChatUrl() {
        return await DataService.get(`${ApiService.EngineerApi}/index/getChatUrl`);
    }

}
